import React, { useEffect, useState } from 'react';
import { useQuery } from "@tanstack/react-query";
import Layout from '../Layout';
import { EditUserModal, StatContainer } from './UserComponent';
import { UserApi } from '../../app/api/user.api';


export function User() 
{

  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState({});

  const [role, setRole] = useState("");
  const [email, setEmail] = useState("");

  const user = UserApi(); 
  const [filteredData, setFilteredData] = useState([]);
  
  const fetchData = async () => { 
    const {data} = await user.findAll();
    return data.users; 
  }
  const { isLoading, data=[], error, refetch } = useQuery({  queryKey: ["users"], queryFn: fetchData });
  
  
  const handleInputs = (event) => {
    const { name, value } = event.target;
    if( name === 'status' ) {
        setRole(value);
    }
    if( name === 'email' ) {
        setEmail(value);
    }
  }

  useEffect(() => {
  
      if (!Array.isArray(data)) return;
      let filtered = data;
  
      if (role) filtered = filtered.filter(item => item.status?.toLowerCase() === role.toLowerCase() );
      if (email) filtered = filtered.filter(item => item.email?.toLowerCase().startsWith(email.toLowerCase()) );
     
      setFilteredData(filtered);
  
  }, [data, role, email]);  

  
  const handleEdit = ( user ) => {
    setSelectedUser( user );
    setShowEditModal(true);
  };

  return (

    <Layout activeMenu={6}>
  
      <div className='container-fluid m-0 bg-white py-5'>
        <div className='row justify-content-center'>
          <div className='col-md-11'>

            <section className='row'>
              <div className='col-12 px-0'>
                 <div className="d-flex flex-column">

                    {/* Vue Grille/Liste */}
                    <div className="d-flex align-items-center gap-3 display-controls mb-3 ps-1">
                      <span className="text-muted lead"><i className="bi bi-grid"></i></span>
                      <span className="text-muted lead"> Statistique des utilisateurs </span>
                    </div>

                    {/* Cartes de Statistiques */}
                    <StatContainer />

                    {/* Barre de Filtres et Contrôles */}
                    <div className="row mt-5">
                      <div className="d-flex gap-3 flex-column flex-md-row justify-content-between align-items-center border-bottom pb-3 mb-4">
                        {/* Vue Grille/Liste */}
                        <div className="d-flex align-items-center gap-3 display-controls">
                          <span className="text-muted lead"><i className="bi bi-grid-3x3-gap-fill"></i></span>
                          <span className="text-muted lead"> Liste des utilisateurs </span>
                        </div>
                        {/* Infos et Tris */}
                        <div className="d-flex align-items-center gap-3 filter-controls">
                           <span className="text-muted small"> { filteredData.length } utilisateur (s) </span>
                        </div>
                      </div>

                      {/* Boutons de Filtres Catégories */}
                      <div className="d-flex gap-2 flex-wrap mb-5">
                        <div className="dropdown">
                          <select className="w-100 text-muted px-3 py-1 border" value={role} name="status" onChange={ handleInputs } required >
                            <option value=""> Choisir status  </option>
                            <option value="user" > User </option>
                            <option value="saler" > Saler </option>
                            <option value="admin" > Admin </option>
                            <option value="topadmin" > Top admin </option>
                            <option value="block" > bloqué </option>
                          </select>
                        </div>
                        <div className="d-flex align-items-center">
                          <input type="search" className="w-100 px-3 py-1 border" placeholder="Rechercher mail" value={email} name="email" onChange={ handleInputs } required />
                          <span className="border py-1 px-2"> <i className="bi bi-search text-muted"></i> </span>                 
                        </div>
                      </div>

                    </div>
                  </div>
               </div>
            </section>

            <section className="row">
                
            {/* Loading */}
              {isLoading && (
                <div className="d-flex flex-column align-items-center mt-4">
                  <div className="spinner-border mb-3" style={{ width: '5rem', height: '5rem', color: '#307072' }}></div>
                  <p className="text-secondary"> Chargement de données en cours...</p>
                </div>
              )}
              
              {/* Error */}
              {!isLoading && error && (
               <div className="text-center p-4 border alert alert-danger w-100">
                 Une erreur est survenue. Veuillez vérifier votre connexion.
               </div>
              )}
              
              {/* Data */}
              {!isLoading && !error && Array.isArray(filteredData) && filteredData.length > 0 && (

                filteredData.map( ( item, index ) => (

                    <div className="col-lg-12 px-0" key={index}>
                        <div className="d-flex gap-3 p-3 flex-column flex-sm-row justify-content-between border mb-4" key={index}>
                          <div className="d-flex align-items-center">
                            <div className="me-2">
                              <div className="border bg-dark text-white rounded-circle d-flex align-items-center justify-content-center fw-bold small" style={{ width:40, height:40}}>
                                { item?.fname ? item.fname.charAt(0).toUpperCase() : ""} { item?.lname ? item.lname.charAt(0).toUpperCase() : ""}
                              </div>
                            </div>
                            <div>
                              <div className="fw-bold text-secondary small" title={ 'Prenom et nom' }> { item?.fname + " " + item?.lname } </div>
                              <div className="fw-bold text-secondary small" title={ 'email' }> { item?.email } </div>
                              <div className="text-secondary small" title={ 'role' }> { item?.status } </div>
                            </div>
                          </div>
                          <div>
                             <button title="Modifier utilisateur" className="btn btn-sm rounded-0 btn-outline-green px-2 mt-2" onClick={() => handleEdit( item )}>
                                 Modifier <i className="bi bi-pencil"> </i> 
                             </button>
                          </div>
                        </div>
                    </div>
                ))
              )}
              
              {/* Liste vide */}
              {!isLoading && !error && Array.isArray(filteredData) && filteredData.length === 0 && (
                <div className="bg-white border p-4 text-center text-secondary w-100">
                  La liste est actuellement vide. Aucun élément n’a été trouvé.
                </div>
              )}
            </section>
                
          </div>   
        </div>
      </div>


      {/* Modal de Modification d'utilisateur */}
      {
        showEditModal && (
          <EditUserModal show={showEditModal} onHide={() => setShowEditModal(false)} user={ selectedUser } refetch={refetch} />
        )
      }
      
    </Layout>

  );
        
}